// extracted by mini-css-extract-plugin
export default {"cobrandGrid":"BrandHeader_cobrandGrid__j9KEp","cobrandItem":"BrandHeader_cobrandItem__H-Ze+"};